import {configureStore,combineReducers} from "@reduxjs/toolkit";
import authReducer from "./authSlide"
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { persistReducer, persistStore} from 'redux-persist';

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = {
    auth: authReducer,
};
const persistedReducer = persistReducer(persistConfig, combineReducers(rootReducer))

export const store =  configureStore({
    reducer: persistedReducer,
    middleware: [thunk]
})

export const persistor = persistStore(store)
